const keyPrefix = 'object_store_';
const defaultMaxAge = 60 * 60 * 24; // default, one day cache

function _getKey(oid) {
    return keyPrefix + encodeURI(oid);
}

function clear() {
    const deleteKeys = [];

    for (const key in window.localStorage) {
        if (key.indexOf(keyPrefix) === 0) {
            deleteKeys.push(key);
        }
    }

    // eslint-disable-next-line no-cond-assign
    for (let n = 0, key; (key = deleteKeys[n++]); ) {
        window.localStorage.removeItem(key);
    }
}

export function get(oid) {
    const cacheKey = _getKey(oid);
    try {
        const cacheEntry = JSON.parse(window.localStorage.getItem(cacheKey));
        if (!cacheEntry) {
            return null;
        }

        const now = new Date().getTime();

        if (cacheEntry.expires > now) {
            return cacheEntry.value;
        } else {
            window.localStorage.removeItem(cacheKey);
        }
    } catch (e) {
        // nop. We didn't have the cached item, or it was malformed.
        // fall through.
    }
    return null;
}

// maxage in seconds
export function put(oid, value, maxAge) {
    maxAge = maxAge || defaultMaxAge;
    const cacheKey = _getKey(oid);
    try {
        const cacheEntry = {
            expires: new Date().getTime() + maxAge * 1000,
            timestamp: new Date().getTime(),
            value,
        };
        window.localStorage.setItem(cacheKey, JSON.stringify(cacheEntry));
    } catch (e) {
        // localstorage or JSON not implemented probably. That's OK
    }
}

function del(oid) {
    const cacheKey = _getKey(oid);
    try {
        window.localStorage.removeItem(cacheKey);
    } catch (e) {}
}

export default {
    name: 'objectstore',
    callable() {
        return {
            get,
            put,
            del,
            clear,
        };
    },
};



// WEBPACK FOOTER //
// ./services/objectStoreService.js